/*
 * P Flash Sale — điều khiển khối Flash Sale (sections/p-flash-sale.liquid).
 *
 * Thời gian và mức giảm đều hỏi PPromo (đọc từ BOGOS):
 *   - đang chạy -> hiện khối, đếm ngược tới giờ đóng, tính giá sau giảm
 *   - sắp chạy  -> hiện khối, đếm ngược tới giờ mở, KHÔNG đổi giá
 *   - không có  -> ẩn cả khối
 *
 * Hết giờ tự chuyển trạng thái, không cần tải lại trang.
 */
(function () {
  'use strict';
  if (window.__pFlashSaleInit) return;
  window.__pFlashSaleInit = true;

  var LABEL_RUNNING = 'Kết thúc sau';
  var LABEL_UPCOMING = 'Bắt đầu sau';

  function P() { return window.PPromo || null; }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function num(el, attr) { return Number(el.getAttribute(attr)) || 0; }
  function sections() { return document.querySelectorAll('[data-p-flash]'); }

  /* ------------------------------------------------------------------ *
   * Ghép khối với đúng đợt flash sale
   * ------------------------------------------------------------------ */

  /** Danh sách collection của khối. Hỗ trợ cả thuộc tính số nhiều lẫn bản cũ. */
  function sectionColls(section) {
    var ids = (section.getAttribute('data-collection-ids') ||
               section.getAttribute('data-collection-id') || '')
      .split(',').map(function (s) { return Number(s.trim()) || 0; })
      .filter(Boolean);
    var handles = (section.getAttribute('data-collection-handles') ||
                   section.getAttribute('data-collection-handle') || '')
      .split(',').map(function (s) { return s.trim(); })
      .filter(Boolean);
    return { ids: ids, handles: handles };
  }

  /**
   * Đợt flash sale đại diện cho cả khối.
   *
   * Khối có thể gom NHIỀU bậc giảm giá = nhiều collection = nhiều offer BOGOS
   * khác nhau. Đồng hồ chỉ có một, nên chọn đợt KẾT THÚC SỚM NHẤT trong số
   * các đợt đang chạy — hết đợt đó là refresh() tính lại, không bao giờ hứa
   * dài hơn thực tế. Giá của từng thẻ KHÔNG lấy từ đây mà tra riêng theo
   * collection của chính thẻ đó (xem paintItem).
   */
  function saleFor(section) {
    var p = P();
    if (!p) return null;

    var c = sectionColls(section);

    // BOGOS chỉ đẩy discount của KHUNG GIỜ HIỆN TẠI ra storefront; ngoài khung
    // thì đợt "sắp mở" dựng từ lịch khai báo tay trong section P Promo.
    var hours = parseFloat(section.getAttribute('data-upcoming-hours'));
    if (isNaN(hours) || hours <= 0) hours = 3;

    var list = p.getFlashSales({ includeUpcoming: true, upcomingWithinMs: hours * 3600000 });
    var mine = [];

    for (var i = 0; i < list.length; i++) {
      var d = list[i];
      var hit = false;

      for (var a = 0; a < c.ids.length && !hit; a++) {
        if (d.collectionIds.indexOf(c.ids[a]) !== -1) hit = true;
      }
      for (var b = 0; b < c.handles.length && !hit; b++) {
        if ((d.collectionHandles || []).indexOf(c.handles[b]) !== -1) hit = true;
      }
      // Đợt không nhắm riêng cái gì (hoặc dựng từ lịch tay) thì áp cho mọi khối.
      if (!hit && !d.collectionIds.length && !d.productIds.length && !d.variantIds.length) {
        hit = true;
      }
      if (hit) mine.push(d);
    }

    if (!mine.length) return null;

    var running = mine.filter(function (d) { return d.state === 'running'; });
    if (running.length) {
      running.sort(function (a, b) { return (a.endsAt || 0) - (b.endsAt || 0); });
      return running[0];
    }

    mine.sort(function (a, b) { return (a.startsAt || 0) - (b.startsAt || 0); });
    return mine[0];
  }

  /* ------------------------------------------------------------------ *
   * Số "đã bán" ước lượng — CỐ ĐỊNH theo sản phẩm + theo ngày.
   *
   * Random mỗi lần tải trang sẽ tự phản chủ: khách F5 thấy "còn 3" nhảy
   * thành "còn 8" là mất tin ngay. Hàm này cho ra cùng một số suốt cả ngày
   * với cùng một sản phẩm, sang ngày mới mới đổi.
   * ------------------------------------------------------------------ */

  function seededPercent(productId, min, max) {
    if (max < min) { var t = min; min = max; max = t; }
    var day = Math.floor(Date.now() / 86400000);
    var x = Math.sin(productId * 9301 + day * 49297) * 233280;
    var frac = x - Math.floor(x);
    return Math.round(min + frac * (max - min));
  }

  function stockInfo(section, item) {
    var qty = num(item, 'data-qty');
    var baseline = num(section, 'data-stock-baseline');
    var low = num(section, 'data-low-stock') || 10;
    var hotMin = num(section, 'data-hot-min') || 55;
    var hotMax = num(section, 'data-hot-max') || 85;
    var pid = num(item, 'data-product-id');

    if (baseline <= 0) return null;

    // Tồn kho thật -> số đã bán thật so với mốc ban đầu
    if (qty > 0) {
      var sold = Math.max(0, baseline - qty);
      var pct = Math.min(95, Math.round((sold / baseline) * 100));
      return {
        percent: Math.max(pct, 5),
        text: qty <= low ? ('Chỉ còn ' + qty + ' sản phẩm') : ('Đã bán ' + sold + ' sản phẩm')
      };
    }

    // Không theo dõi tồn kho -> mức ước lượng cố định theo ngày, quy ra số sản phẩm
    var est = seededPercent(pid, hotMin, hotMax);
    var estSold = Math.max(1, Math.round((est / 100) * baseline));
    return { percent: est, text: 'Đã bán ' + estSold + ' sản phẩm' };
  }

  /* ------------------------------------------------------------------ *
   * Giá + tiết kiệm
   * ------------------------------------------------------------------ */

  /**
   * Che giá lúc ĐANG ĐẾM NGƯỢC trước giờ mở: 349.000đ giảm 50.000 -> "2??.000đ".
   * Chỉ lộ chữ số đầu để gợi tò mò mà vẫn nói đúng bậc giá.
   *
   * Lúc này BOGOS CHƯA gửi offer ra web nên không có cách nào biết giá thật.
   * Mức giảm dự kiến do người quản trị khai trong từng bậc (data-expect-off,
   * đơn vị VND thực). Không khai thì che hết thành "???.000đ" — thà mập mờ
   * còn hơn hiện sai chữ số đầu.
   *
   * @param {number} cents  giá hiện tại (đơn vị nhỏ nhất, VND*100)
   * @param {number} offVnd mức giảm dự kiến, VND thực
   */
  var TEASE_ALL = '???.000đ';

  function teasePrice(cents, offVnd) {
    if (!offVnd || offVnd <= 0) return TEASE_ALL;
    var out = cents - offVnd * 100;
    if (out <= 0) return TEASE_ALL;

    var k = Math.round(out / 100000); // VND*100 -> nghìn đồng
    if (k < 10) return TEASE_ALL;

    // "299" -> "2??" ; "1010" -> "1???"
    var str = String(k);
    var masked = str.charAt(0) + new Array(str.length).join('?');

    // Chấm phân cách hàng nghìn theo kiểu Việt: "1???" -> "1.???".
    // KHÔNG dùng \B ở đây: ký tự '?' không phải chữ nên ranh giới từ không
    // rơi đúng chỗ, "1???" sẽ ra "1???" thay vì "1.???" (đã dính lỗi này).
    var out2 = '';
    for (var i = 0; i < masked.length; i++) {
      if (i > 0 && (masked.length - i) % 3 === 0) out2 += '.';
      out2 += masked.charAt(i);
    }

    return out2 + '.000đ';
  }

  /** @returns {boolean} thẻ này CÓ đang được giảm giá không */
  function paintItem(section, item, collIds, running) {
    var p = P();
    var price = num(item, 'data-price');
    var compare = num(item, 'data-compare');
    if (!price) return false;

    var now = item.querySelector('[data-p-flash-now]');
    var was = item.querySelector('[data-p-flash-was]');
    var badge = item.querySelector('[data-p-flash-badge]');

    var res = p.getFlashPrice(
      price,
      num(item, 'data-variant-id'),
      num(item, 'data-product-id'),
      collIds
    );

    var finalPrice = res ? res.price : price;
    var fsSaved = res ? res.saved : 0;

    // Chưa tới giờ mở + bật che giá -> hiện "2??K" thay vì giá thường.
    var teasing = !running && section.getAttribute('data-tease-price') === '1';

    if (teasing) {
      if (now) now.textContent = teasePrice(price, num(item, 'data-expect-off'));
      if (was) { was.textContent = p.money(price); was.hidden = false; }
      if (badge) badge.hidden = true; // chưa lộ mức giảm
      item.classList.remove('is-flash');
      item.classList.add('is-tease');
      paintStock(section, item);
      return false;
    }

    item.classList.remove('is-tease');

    if (now) now.textContent = p.money(finalPrice);

    if (was) {
      if (compare > finalPrice) {
        was.textContent = p.money(compare);
        was.hidden = false;
      } else if (res && price > finalPrice) {
        was.textContent = p.money(price);
        was.hidden = false;
      } else {
        was.hidden = true;
      }
    }

    if (badge) {
      if (fsSaved > 0) {
        badge.textContent = '-' + p.money(fsSaved);
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }

    item.classList.toggle('is-flash', !!res);
    paintStock(section, item);

    return !!res;
  }

  function paintStock(section, item) {
    var stockBox = item.querySelector('[data-p-flash-stock]');
    if (!stockBox) return;
    var info = stockInfo(section, item);
    if (info) {
      var txt = item.querySelector('[data-p-flash-stock-text]');
      var fill = item.querySelector('[data-p-flash-stock-fill]');
      if (txt) txt.textContent = info.text;
      if (fill) fill.style.width = info.percent + '%';
      stockBox.hidden = false;
    } else {
      stockBox.hidden = true;
    }
  }

  /**
   * @param {boolean} running Đợt đang CHẠY thật (có mức giảm để tính), khác
   *        với trạng thái "sắp mở" — lúc sắp mở chưa có mức giảm nào nên
   *        không được lấy đó làm cớ ẩn sản phẩm.
   * @returns {number} số thẻ còn hiện
   */
  function paintAll(section, running) {
    var fallback = sectionColls(section).ids;
    var onlyDisc = section.getAttribute('data-only-discounted') === '1';
    var items = section.querySelectorAll('[data-p-flash-item]');
    var shown = 0;

    for (var i = 0; i < items.length; i++) {
      // Mỗi thẻ tra mức giảm theo collection CỦA CHÍNH NÓ. Đây là chỗ khiến
      // ba bậc giảm khác nhau nằm chung một slider mà vẫn ra đúng giá.
      var own = num(items[i], 'data-collection-id');
      var hasDisc = paintItem(section, items[i], own ? [own] : fallback, running);

      // Sản phẩm không nằm trong đợt giảm nào thì không có lý do gì đứng
      // trong slider Flash Sale — ẩn đi thay vì để khách tưởng nó đang sale.
      var hide = onlyDisc && running && !hasDisc;
      items[i].hidden = hide;
      if (!hide) shown++;
    }
    return shown;
  }

  function resetAll(section) {
    var items = section.querySelectorAll('[data-p-flash-item]');
    for (var i = 0; i < items.length; i++) {
      items[i].classList.remove('is-flash');
      items[i].hidden = false;
    }
  }

  /**
   * Xáo thứ tự thẻ (Fisher-Yates). Chạy MỘT lần lúc khởi động, trước khi vẽ,
   * nên khách không thấy thẻ nhảy chỗ. Mỗi lần tải trang một thứ tự khác.
   */
  function shuffleTrack(section) {
    var track = section.querySelector('.p-flash__track');
    if (!track) return;
    var items = [];
    for (var i = 0; i < track.children.length; i++) items.push(track.children[i]);
    for (var j = items.length - 1; j > 0; j--) {
      var k = Math.floor(Math.random() * (j + 1));
      var tmp = items[j]; items[j] = items[k]; items[k] = tmp;
    }
    var frag = document.createDocumentFragment();
    for (var m = 0; m < items.length; m++) frag.appendChild(items[m]);
    track.appendChild(frag);
  }

  /* ------------------------------------------------------------------ *
   * Đồng hồ + trạng thái
   * ------------------------------------------------------------------ */

  var _stops = [];

  function stopAll() {
    for (var i = 0; i < _stops.length; i++) {
      try { _stops[i](); } catch (e) {}
    }
    _stops.length = 0;
  }

  function paintTimer(section, target, label) {
    var p = P();
    var box = section.querySelector('[data-p-flash-timer]');
    if (!box || !p) return;

    var lbl = section.querySelector('[data-p-flash-timer-label]');
    if (lbl) lbl.textContent = label;
    box.hidden = false;

    var hh = section.querySelector('[data-p-flash-hh]');
    var mm = section.querySelector('[data-p-flash-mm]');
    var ss = section.querySelector('[data-p-flash-ss]');

    _stops.push(p.countdown(target, function (t) {
      // Không có ô "ngày" nữa -> dồn hết vào giờ (vd 26 giờ)
      if (hh) hh.textContent = pad2(t.hours + t.days * 24);
      if (mm) mm.textContent = pad2(t.minutes);
      if (ss) ss.textContent = pad2(t.seconds);
      if (t.done) setTimeout(refresh, 1200); // đóng đợt -> tính lại trạng thái
    }));
  }

  function refresh() {
    stopAll();

    var list = sections();
    for (var i = 0; i < list.length; i++) {
      var section = list[i];
      var sale = saleFor(section);

      resetAll(section);

      if (!sale) {
        section.hidden = true;
        continue;
      }

      if (sale.state === 'running') {
        section.hidden = false;
        section.classList.add('is-running');
        section.classList.remove('is-upcoming');
        if (paintAll(section, true) === 0) {
          // Đang trong khung giờ nhưng KHÔNG sản phẩm nào thuộc đợt giảm nào
          // -> khối rỗng, ẩn hẳn thay vì hiện một slider trắng.
          section.hidden = true;
          continue;
        }
        paintTimer(section, sale.endsAt, LABEL_RUNNING);
        continue;
      }

      if (sale.state === 'upcoming' && section.getAttribute('data-show-upcoming') === '1') {
        section.hidden = false;
        section.classList.add('is-upcoming');
        section.classList.remove('is-running');
        paintAll(section, false); // chưa tới giờ: giữ nguyên giá, KHÔNG ẩn thẻ nào
        paintTimer(section, sale.startsAt, LABEL_UPCOMING);
        continue;
      }

      section.hidden = true;
    }
  }

  function start() {
    var all = sections();
    if (!all.length) return;

    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute('data-card-order') === 'random') shuffleTrack(all[i]);
    }

    if (window.PPromo) {
      window.PPromo.ready(refresh);
      window.PPromo.onChange(refresh);
      return;
    }

    // p-promo-core.js nạp defer — chờ bằng setTimeout, không dùng rAF.
    var tries = 40;
    (function wait() {
      if (window.PPromo) { start(); return; }
      if (tries-- <= 0) return;
      setTimeout(wait, 150);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
